import {ChangesTemplate} from "../../templates/ChangesTemplate/ChangesTemplate";

const ChangesPage = () => {
  return <ChangesTemplate />;
};

export default ChangesPage;
